import { Device } from 'src/types/IDevices';
import { SubscriptionsData, Subscription } from '@uma/react-commons/dist/index';

interface SubscriptionsPayload {
  device: Pick<Device, 'deviceId' | 'identity' | 'type'> | undefined;
  subscriptionsData:
    | {
        data?: {
          account?: {
            subscriptions?: Subscription[];
          };
        };
        loading?: boolean;
        error?: Error;
      }
    | undefined;
}

export const buildSubscriptionsPayload = (
  device: Device | undefined,
  subscriptionsData: SubscriptionsData | undefined
): SubscriptionsPayload => {
  return {
    device: device
      ? {
          deviceId: device.deviceId,
          identity: device.identity,
          type: device.type
        }
      : undefined,
    subscriptionsData: subscriptionsData
      ? {
          data: {
            account: {
              subscriptions: [
                ...(subscriptionsData?.data?.account?.subscriptions ?? [])
              ]
            }
          },
          loading: subscriptionsData.loading,
          error: subscriptionsData.error
        }
      : undefined
  };
};
